import { render } from "./BenutzerObj.vue?vue&type=template&id=7884164d"
import script from "./BenutzerObj.vue?vue&type=script&lang=js"
export * from "./BenutzerObj.vue?vue&type=script&lang=js"

import "./BenutzerObj.vue?vue&type=style&index=0&id=7884164d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__